import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./charts/ChartjsConfig";
import "./css/style.css";
import { NotificationsProvider } from "./shared/context/NotificationsContext";

import ProtectedRoute from "./components/routing/ProtectedRoute";
import routes from "./config/routes.ts";
import { userService } from "./features/auth/services/userService";

function App() {
  const location = useLocation();
  const isUserAuthenticated = userService.isUserAuthenticated();

  useEffect(() => {
    document.querySelector("html").style.scrollBehavior = "auto";
    window.scroll({ top: 0 });
    document.querySelector("html").style.scrollBehavior = "";
  }, [location.pathname]);

  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route>
          {!isUserAuthenticated && (
            <Route path="*" element={<Navigate to="/404" replace />} />
          )}
          {routes.public.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={<route.component />}
            />
          ))}
        </Route>

        {/* Protected routes */}
        <Route>
          {isUserAuthenticated && (
            <Route path="*" element={<Navigate to="/not-found" replace />} />
          )}
          {routes.protected.map((route) => {
            if (route.children) {
              return route.children.map((childRoute) => (
                <Route
                  key={`${route.path}/${childRoute.path}`}
                  path={`${route.path}/${childRoute.path}`}
                  element={
                    <ProtectedRoute>
                      <NotificationsProvider>
                        <childRoute.component />
                      </NotificationsProvider>
                    </ProtectedRoute>
                  }
                />
              ));
            }
            return (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <ProtectedRoute>
                    <NotificationsProvider>
                      <route.component />
                    </NotificationsProvider>
                  </ProtectedRoute>
                }
              />
            );
          })}
        </Route>

        {/* Onboarding routes */}
        <Route>
          {routes.onboarding.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <ProtectedRoute>
                  <route.component />
                </ProtectedRoute>
              }
            />
          ))}
        </Route>
      </Routes>
    </>
  );
}

export default App;
